// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__19KaV","name":"Header_name__ficuy","birthday":"Header_birthday__BThem","skeleton":"Header_skeleton__3sMAz"};